import React, { useEffect, useState } from 'react';

export default function FooterCustom ({FooterData}) {
	const [Url, setUrl] = useState('');
	const [FrameHight, setFrameHight] = useState('');
	useEffect(()=>{
		let url = '';
		let frameHight = '0';

		if (FooterData.length > 0) {
			url = FooterData[0]['URL'];
			frameHight = FooterData[0]['Size'];
		}
		setUrl(url);
		setFrameHight(frameHight);
	},[]);

	return (
		<footer>
			<iframe
				id="FooterFrame"
				src={Url}
				width="100%"
				height={FrameHight}
				frameBorder="0"
				scrolling="no"
				border="0"
				allowTransparency=""
			/>
		</footer>
	);
}
